import React, { Suspense } from 'react'
import { Search, Trello, TrendingUp } from 'react-feather'
import { useLocation } from 'react-router'

import AppHeader from '@/components/layouts/DashboardLayout/components/DashboardSidebar/components/AppHeader'
import DashboardSidebar from '@/components/layouts/DashboardLayout/components/DashboardSidebar/DashboardSidebar'
import DashboardSidebarProvider from '@/components/layouts/DashboardLayout/components/DashboardSidebar/DashboardSidebarProvider'
import Footer from '@/components/layouts/DashboardLayout/components/Footer'
import PageContent from '@/components/misc/PageContent'
import SentryErrorBoundary from '@/components/misc/SentryErrorBoundary'
import { SidebarInset } from '@/components/ui/sidebar'
import LoadingWidget from '@/components/widgets/LoadingWidget'
import { ROUTES } from '@/lib/routes'
import { SidebarLink } from '@/types/misc'

interface Props {
  children: React.ReactNode
}

const IcaewDashboardLayout: React.FC<Props> = ({ children }) => {
  const location = useLocation()

  function buildSidebarLinks(): SidebarLink[] {
    return [
      {
        href: ROUTES.icaewOverview(),
        icon: <Trello />,
        title: 'Overview',
      },
      {
        href: ROUTES.icaewFirmSearch(),
        icon: <Search />,
        title: 'Firm Search',
      },
      {
        href: ROUTES.icaewTrends(),
        icon: <TrendingUp />,
        title: 'Trends',
      },
    ]
  }

  const sidebarLinks = buildSidebarLinks()

  return (
    <DashboardSidebarProvider>
      <DashboardSidebar links={sidebarLinks} />

      <SidebarInset className="min-w-0">
        <AppHeader />
        <PageContent>
          <SentryErrorBoundary key={location.pathname}>
            <Suspense fallback={<LoadingWidget />}>{children}</Suspense>
          </SentryErrorBoundary>
        </PageContent>
        <Footer />
      </SidebarInset>
    </DashboardSidebarProvider>
  )
}

export default IcaewDashboardLayout
